import { ResetPasswordForm } from '@/components/auth/auth-reset-password-form'
import { useSearchParams } from 'react-router'

export function AuthResetPasswordPage() {
  const [searchParams] = useSearchParams()

  return (
    <div className="bg-background flex h-screen w-full items-center justify-center">
      <div className="mx-auto flex max-w-md flex-1 flex-col justify-center">
        <div className="shadow-xs border-border bg-card relative mb-16 overflow-hidden rounded-md border p-6">
          <div className="relative z-10">
            <ResetPasswordForm token={searchParams.get('token') || ''} />
          </div>
        </div>
      </div>
    </div>
  )
}
